import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import * as path from '../../util/pathConstructor';
import tagular from '../../util/tagular';
import * as eventsApi from '../../api/eventsApi';

import InlineWhisper from '../inlineWhisper/inlinewhisper';

import './intro.scss';

class Intro extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    assessmentLink() {
        const { assessment, location } = this.props;

        return path.getPromptPath(assessment.name, location.search, assessment.rootPrompt);
    }

    handleClick(e) {
        const { assessment, inlineParentMetadata } = this.props;

        eventsApi.assessmentStarted(assessment, {
            text: e.currentTarget.text,
            inlineParentMetadata
        });

        tagular.sendFormStartedEvent(e, { assessment });
    }

    render() {
        const { inlineInfo, inlineConfig, introConfig, assessment } = this.props;

        return (
            <div className="intro">
                <InlineWhisper
                    isInline={inlineInfo.status}
                    whisper={inlineConfig.whisper}
                    site={assessment.site || 'hl'}
                />

                <div className={`intro-title ${assessment.site}`}>{introConfig.title}</div>
                <div className={`intro-description ${assessment.site}`}>{introConfig.briefDescription}</div>
                <Link
                    to={`${this.assessmentLink()}`}
                    onClick={this.handleClick}
                    className={`intro-cta ${assessment.site}`}
                >
                    {introConfig.cta || 'START ASSESSMENT'}
                </Link>
                <a
                    href={assessment.privacyPolicyUrl}
                    target="_blank"
                    className="privacy-text"
                    rel="noreferrer"
                >
                    Your <span className="privacy">privacy</span> is important to us
                </a>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        assessment: state.app.assessment,
        inlineParentMetadata: state.inline.parentMetadata,
        introConfig: state.app.assessment.introConfig || {},
        inlineInfo: state.inline.info,
        inlineConfig: state.inline.config
    };
};

export default withRouter(connect(mapStateToProps, null)(Intro));
